import { motion } from "framer-motion";
import { organizerInfo } from "@/data/dummy";


export const CampaignOrganizerSection = () => {
  return (
    <motion.section
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="py-20 px-4 border-t border-border"
    >
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="font-sans font-normal tracking-tight text-3xl md:text-4xl text-foreground mb-10">Campaign Organizer</h2>
          
          <div className="bg-card rounded-lg p-8 shadow-card border border-border">
            <div className="flex flex-col md:flex-row gap-8 items-start">
              {/* Organizer Avatar */}
              <div className="flex-shrink-0">
                <img
                  src={organizerInfo.photo}
                  alt={organizerInfo.name}
                  className="w-24 h-24 rounded-full object-cover shadow-soft"
                />
              </div>

              {/* Organizer Details */}
              <div className="flex-1 space-y-6">
                <div>
                  <h4 className="text-xl font-medium text-foreground font-sans tracking-wide">
                    {organizerInfo.name}
                  </h4>
                  <p className="text-sm uppercase tracking-widest text-muted-foreground mt-1">Investor by day, experimenter by night</p>
                </div>
                
                <div className="text-base leading-relaxed text-foreground space-y-4 font-sans">
                  {organizerInfo.bio.split('\n\n').map((paragraph, index) => (
                    <p key={index} dangerouslySetInnerHTML={{
                      __html: paragraph.replace(
                        /\[([^\]]+)\]\(([^)]+)\)/g,
                        '<a href="$2" target="_blank" rel="noopener noreferrer" class="text-primary hover:text-accent underline-offset-4 hover:underline">$1</a>'
                      )
                    }} />
                  ))}
                </div>

                {/* Twitter Follow Button */}
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => window.open(organizerInfo.twitterUrl, '_blank')}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors text-sm shadow-button"
                >
                  Follow {organizerInfo.twitterHandle}
                </motion.button>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};